/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCompletionsV2QueryVariables = Types.Exact<{
  language: Types.CompletionLanguage;
  editableRegion: Types.Scalars["String"]["input"];
  prefix: Types.Scalars["String"]["input"];
  suffix: Types.Scalars["String"]["input"];
  upstreamContext: Types.Scalars["String"]["input"];
  dataframeContext:
    | ReadonlyArray<Types.Scalars["CompletionDataFrameSchema"]["input"]>
    | Types.Scalars["CompletionDataFrameSchema"]["input"];
  editHistoryEvents:
    | ReadonlyArray<Types.EditHistoryEvent>
    | Types.EditHistoryEvent;
}>;

export type GetCompletionsV2Query = {
  readonly __typename: "Query";
  readonly getCompletionsV2: {
    readonly __typename: "CompletionResultV2";
    readonly result: string | null;
    readonly magicCompletionEvent: {
      readonly __typename: "MagicCompletionEvent";
      readonly id: c.MagicCompletionEventId;
    };
  };
};

export type TrackInlineCompletionEventDisplayedMutationVariables = Types.Exact<{
  completionId: Types.Scalars["MagicCompletionEventId"]["input"];
}>;

export type TrackInlineCompletionEventDisplayedMutation = {
  readonly __typename: "Mutation";
  readonly trackInlineCompletionEventDisplayed: string;
};

export type TrackInlineCompletionEventReviewedMutationVariables = Types.Exact<{
  completionId: Types.Scalars["MagicCompletionEventId"]["input"];
  accepted: Types.Scalars["Boolean"]["input"];
}>;

export type TrackInlineCompletionEventReviewedMutation = {
  readonly __typename: "Mutation";
  readonly trackInlineCompletionEventReviewed: string;
};

export const GetCompletionsV2Document = /*#__PURE__*/ gql`
  query GetCompletionsV2(
    $language: CompletionLanguage!
    $editableRegion: String!
    $prefix: String!
    $suffix: String!
    $upstreamContext: String!
    $dataframeContext: [CompletionDataFrameSchema!]!
    $editHistoryEvents: [EditHistoryEvent!]!
  ) {
    getCompletionsV2(
      language: $language
      editableRegion: $editableRegion
      prefix: $prefix
      suffix: $suffix
      upstreamContext: $upstreamContext
      dataframeContext: $dataframeContext
      editHistoryEvents: $editHistoryEvents
    ) {
      result
      magicCompletionEvent {
        id
      }
    }
  }
`;

/**
 * __useGetCompletionsV2Query__
 *
 * To run a query within a React component, call `useGetCompletionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionsV2Query({
 *   variables: {
 *      language: // value for 'language'
 *      editableRegion: // value for 'editableRegion'
 *      prefix: // value for 'prefix'
 *      suffix: // value for 'suffix'
 *      upstreamContext: // value for 'upstreamContext'
 *      dataframeContext: // value for 'dataframeContext'
 *      editHistoryEvents: // value for 'editHistoryEvents'
 *   },
 * });
 */
export function useGetCompletionsV2Query(
  baseOptions: Apollo.QueryHookOptions<
    GetCompletionsV2Query,
    GetCompletionsV2QueryVariables
  > &
    (
      | { variables: GetCompletionsV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompletionsV2Query, GetCompletionsV2QueryVariables>(
    GetCompletionsV2Document,
    options,
  );
}
export function useGetCompletionsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompletionsV2Query,
    GetCompletionsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCompletionsV2Query,
    GetCompletionsV2QueryVariables
  >(GetCompletionsV2Document, options);
}
export function useGetCompletionsV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCompletionsV2Query,
    GetCompletionsV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCompletionsV2Query,
    GetCompletionsV2QueryVariables
  >(GetCompletionsV2Document, options);
}
export type GetCompletionsV2QueryHookResult = ReturnType<
  typeof useGetCompletionsV2Query
>;
export type GetCompletionsV2LazyQueryHookResult = ReturnType<
  typeof useGetCompletionsV2LazyQuery
>;
export type GetCompletionsV2SuspenseQueryHookResult = ReturnType<
  typeof useGetCompletionsV2SuspenseQuery
>;
export type GetCompletionsV2QueryResult = Apollo.QueryResult<
  GetCompletionsV2Query,
  GetCompletionsV2QueryVariables
>;
export const TrackInlineCompletionEventDisplayedDocument = /*#__PURE__*/ gql`
  mutation TrackInlineCompletionEventDisplayed(
    $completionId: MagicCompletionEventId!
  ) {
    trackInlineCompletionEventDisplayed(completionId: $completionId)
  }
`;
export type TrackInlineCompletionEventDisplayedMutationFn =
  Apollo.MutationFunction<
    TrackInlineCompletionEventDisplayedMutation,
    TrackInlineCompletionEventDisplayedMutationVariables
  >;

/**
 * __useTrackInlineCompletionEventDisplayedMutation__
 *
 * To run a mutation, you first call `useTrackInlineCompletionEventDisplayedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInlineCompletionEventDisplayedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInlineCompletionEventDisplayedMutation, { data, loading, error }] = useTrackInlineCompletionEventDisplayedMutation({
 *   variables: {
 *      completionId: // value for 'completionId'
 *   },
 * });
 */
export function useTrackInlineCompletionEventDisplayedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackInlineCompletionEventDisplayedMutation,
    TrackInlineCompletionEventDisplayedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackInlineCompletionEventDisplayedMutation,
    TrackInlineCompletionEventDisplayedMutationVariables
  >(TrackInlineCompletionEventDisplayedDocument, options);
}
export type TrackInlineCompletionEventDisplayedMutationHookResult = ReturnType<
  typeof useTrackInlineCompletionEventDisplayedMutation
>;
export type TrackInlineCompletionEventDisplayedMutationResult =
  Apollo.MutationResult<TrackInlineCompletionEventDisplayedMutation>;
export type TrackInlineCompletionEventDisplayedMutationOptions =
  Apollo.BaseMutationOptions<
    TrackInlineCompletionEventDisplayedMutation,
    TrackInlineCompletionEventDisplayedMutationVariables
  >;
export const TrackInlineCompletionEventReviewedDocument = /*#__PURE__*/ gql`
  mutation TrackInlineCompletionEventReviewed(
    $completionId: MagicCompletionEventId!
    $accepted: Boolean!
  ) {
    trackInlineCompletionEventReviewed(
      completionId: $completionId
      accepted: $accepted
    )
  }
`;
export type TrackInlineCompletionEventReviewedMutationFn =
  Apollo.MutationFunction<
    TrackInlineCompletionEventReviewedMutation,
    TrackInlineCompletionEventReviewedMutationVariables
  >;

/**
 * __useTrackInlineCompletionEventReviewedMutation__
 *
 * To run a mutation, you first call `useTrackInlineCompletionEventReviewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInlineCompletionEventReviewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInlineCompletionEventReviewedMutation, { data, loading, error }] = useTrackInlineCompletionEventReviewedMutation({
 *   variables: {
 *      completionId: // value for 'completionId'
 *      accepted: // value for 'accepted'
 *   },
 * });
 */
export function useTrackInlineCompletionEventReviewedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackInlineCompletionEventReviewedMutation,
    TrackInlineCompletionEventReviewedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackInlineCompletionEventReviewedMutation,
    TrackInlineCompletionEventReviewedMutationVariables
  >(TrackInlineCompletionEventReviewedDocument, options);
}
export type TrackInlineCompletionEventReviewedMutationHookResult = ReturnType<
  typeof useTrackInlineCompletionEventReviewedMutation
>;
export type TrackInlineCompletionEventReviewedMutationResult =
  Apollo.MutationResult<TrackInlineCompletionEventReviewedMutation>;
export type TrackInlineCompletionEventReviewedMutationOptions =
  Apollo.BaseMutationOptions<
    TrackInlineCompletionEventReviewedMutation,
    TrackInlineCompletionEventReviewedMutationVariables
  >;
